interface GameInviteOfflineConfirmProps {
  participantNames: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function GameInviteOfflineConfirm({
  participantNames,
  onConfirm,
  onCancel,
}: GameInviteOfflineConfirmProps) {
  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div
        className="modal-content game-invite-offline-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="game-invite-offline-title"
      >
        <div className="modal-header">
          <h2 id="game-invite-offline-title">Aucun joueur connecté</h2>
          <button type="button" className="modal-close" onClick={onCancel} aria-label="Fermer">
            ×
          </button>
        </div>
        <div className="game-invite-offline-body">
          <p>
            {participantNames} {participantNames.includes(',') || participantNames.includes(' et ') ? 'ne sont' : "n'est"} pas
            connecté{participantNames.includes(',') || participantNames.includes(' et ') ? 's' : ''} pour le moment.
          </p>
          <p>
            Envoyer quand même l'invitation dans la conversation ? Les joueurs pourront répondre
            lorsqu'ils se connecteront, tant que la table est encore en préparation.
          </p>
        </div>
        <div className="game-invite-offline-actions">
          <button type="button" className="game-invite-offline-btn secondary" onClick={onCancel}>
            Annuler
          </button>
          <button type="button" className="game-invite-offline-btn primary" onClick={onConfirm}>
            Envoyer l'invitation
          </button>
        </div>
      </div>
    </div>
  );
}
